import React from "react";

const LockIcon2 = () => {
  return (
    <svg
      width="16"
      height="20"
      viewBox="0 0 16 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.05775 20C1.55908 20 1.13308 19.8234 0.77975 19.4703C0.426583 19.1169 0.25 18.6909 0.25 18.1923V8.80775C0.25 8.30908 0.426583 7.88308 0.77975 7.52975C1.13308 7.17658 1.55908 7 2.05775 7H3.25V5C3.25 3.75133 3.68783 2.68917 4.5635 1.8135C5.43917 0.937833 6.50133 0.5 7.75 0.5C8.99867 0.5 10.0608 0.937833 10.9365 1.8135C11.8122 2.68917 12.25 3.75133 12.25 5V7H13.4423C13.9409 7 14.3669 7.17658 14.7203 7.52975C15.0734 7.88308 15.25 8.30908 15.25 8.80775V18.1923C15.25 18.6909 15.0734 19.1169 14.7203 19.4703C14.3669 19.8234 13.9409 20 13.4423 20H2.05775ZM2.05775 18.5H13.4423C13.5321 18.5 13.6058 18.4712 13.6635 18.4135C13.7212 18.3558 13.75 18.2821 13.75 18.1923V8.80775C13.75 8.71792 13.7212 8.64417 13.6635 8.5865C13.6058 8.52883 13.5321 8.5 13.4423 8.5H2.05775C1.96792 8.5 1.89417 8.52883 1.8365 8.5865C1.77883 8.64417 1.75 8.71792 1.75 8.80775V18.1923C1.75 18.2821 1.77883 18.3558 1.8365 18.4135C1.89417 18.4712 1.96792 18.5 2.05775 18.5ZM7.75 15.25C8.23583 15.25 8.649 15.0798 8.9895 14.7395C9.32983 14.399 9.5 13.9858 9.5 13.5C9.5 13.0142 9.32983 12.601 8.9895 12.2605C8.649 11.9202 8.23583 11.75 7.75 11.75C7.26417 11.75 6.851 11.9202 6.5105 12.2605C6.17017 12.601 6 13.0142 6 13.5C6 13.9858 6.17017 14.399 6.5105 14.7395C6.851 15.0798 7.26417 15.25 7.75 15.25ZM4.75 7H10.75V5C10.75 4.16667 10.4583 3.45833 9.875 2.875C9.29167 2.29167 8.58333 2 7.75 2C6.91667 2 6.20833 2.29167 5.625 2.875C5.04167 3.45833 4.75 4.16667 4.75 5V7Z"
        fill="#4A4A4A"
      />
    </svg>
  );
};

export default LockIcon2;
